import { render } from "./EmployeeReviewsTable.vue?vue&type=template&id=687f38e2"
import script from "./EmployeeReviewsTable.vue?vue&type=script&lang=js"
export * from "./EmployeeReviewsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__